import type { ProjecaoDialogProps } from "./types-projecao-dialog";
import { useProjecaoDialog } from "./use-projecao-dialog";
import { ProjecaoDialogView } from "./view-projecao-dialog";

export function ProjecaoDialog(props: ProjecaoDialogProps) {
  const vm = useProjecaoDialog(props);

  return <ProjecaoDialogView {...vm} />;
}

export type * from "./types-projecao-dialog";
